import React, { Fragment } from "react";
import { KeyValUnderline } from "../../../../libraries/ReportGenerator/KeyValUnderline";
const getFormatterAdjustment = (values) => {
  if (!values || !Array.isArray(values)) return null;
  return (
    <div>
      {values.map((rows, index) => {
        return (
          <div style={{ display: "flex", flexFlow: "wrap", padding: "5px" }}>
            {rows.map((property) => {
              const { titleOnly, title, value } = property;
              if (titleOnly) return <KeyValUnderline key={index} title={titleOnly} titleOnly={true} />;
              return <KeyValUnderline key={index} value={value} title={title} />;
            })}
          </div>
        );
      })}
    </div>
  );
};

export const SCFE_RecordOfDisturbanceReportSchema = {
  typeOfAdjustmentDisturbance: {
    heights: {
      header1: "50px",
    },
    minDataRowsCount: 11,
    columns: [
      {
        title: "Type of Adjustment/Disturbance",
        colSpan: 18,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "values",
        formatter: getFormatterAdjustment,
      },
    ],
  },
};

export const getTypeOfAdjFormDataRows = (formSummary) => {
  function getVal(id) {
    return formSummary[id];
  }
  return [
    {
      qty: getVal("toad_1rr_qty"),
      values: [
        [
          { title: "Repair Rail Installed", value: getVal("toad_1rr_1rri") },
          { title: "Bolted", value: getVal("toad_1rr_2bolt") },
          { title: "Length (ft)", value: getVal("toad_1rr_3len") },
          { title: "In", value: getVal("toad_1rr_4in") },
          { title: "Out", value: getVal("toad_1rr_5out") },
          { title: "Other", value: getVal("toad_1rr_6oth") },
        ],
      ],
    },
    {
      qty: getVal("toad_2tp_qty"),
      values: [
        [
          { title: "Track Panel (s) Installed", value: getVal("toad_2tp_1tpi") },
          { title: "Length (ft)", value: getVal("toad_2tp_2len") },
          { title: "Bolted", value: getVal("toad_2tp_3bot") },
          { title: "Welded", value: getVal("toad_2tp_4weld") },
        ],
      ],
    },
    {
      qty: getVal("toad_3t_qty"),
      values: [
        [
          { title: "Turnout Installed", value: getVal("toad_3t_1ti") },
          { title: "Turnout Size", value: getVal("toad_3t_2tz") },
        ],
      ],
    },
    {
      qty: getVal("toad_4rc_qty"),
      values: [
        [
          { title: "Road Crossing Installed", value: getVal("toad_4rc_1rci") },
          { title: "Length", value: getVal("toad_4rc_2len") },
          { title: "Bolted", value: getVal("toad_4rc_3bolt") },
          { title: "Welded", value: getVal("toad_4rc_4weld") },
        ],
      ],
    },
    {
      qty: getVal("toad_5t_qty"),
      values: [
        [
          { title: "Ties Installed", value: getVal("toad_5t_1ti") },
          { titleOnly: "Tie Counts > " },
          { title: "8' 6\"", value: getVal("toad_5t_4fi") },
          { title: "9'", value: getVal("toad_5t_5f") },
          { title: "10'", value: getVal("toad_5t_6f") },
          { title: "11'", value: getVal("toad_5t_7f") },
          { title: "12'", value: getVal("toad_5t_8f") },
          { title: "13'", value: getVal("toad_5t_9f") },
          { title: "14'", value: getVal("toad_5t_10f") },
          { title: "15'", value: getVal("toad_5t_11f") },
          { title: "16'", value: getVal("toad_5t_12f") },
          { title: "16' 6\"", value: getVal("toad_5t_13f") },
          { title: "Concrete", value: getVal("toad_5t_14c") },
          { title: "Head Block", value: getVal("toad_5t_15hb") },
          { title: "Other", value: getVal("toad_5t_16o") },
        ],
      ],
    },
    {
      qty: getVal("toad_6sot_qty"),
      values: [
        [
          { titleOnly: "Surfacing of Track > " },
          { title: "Inches of Lift", value: getVal("toad_6sot_1iol") },
          { title: "Length of Surfacing", value: getVal("toad_6sot_2los") },
        ],
      ],
    },
    {
      qty: getVal("toad_7roc_qty"),
      values: [
        [{ titleOnly: "Realignment of Curve" }],
        [
          { titleOnly: "Existing > " },
          { title: "Length of Curve", value: getVal("toad_7roc_1loc") },
          { title: "Deg of Curve", value: getVal("toad_7roc_2doc") },
          { title: "Super Elevation", value: getVal("toad_7roc_3se") },
        ],
        [
          { titleOnly: "New > " },
          { title: "Length of Curve", value: getVal("toad_7roc_4loc") },
          { title: "Deg of Curve", value: getVal("toad_7roc_5doc") },
          { title: "Super Elevation", value: getVal("toad_7roc_6se") },
        ],
      ],
    },
    {
      qty: getVal("toad_8bt_qty"),
      values: [
        [
          { titleOnly: "Buckled Track > " },
          { title: "Length of Track Disturbed", value: getVal("toad_8bt_1lotd") },
          { title: "Rail Temp", value: getVal("toad_8bt_2rt") },
        ],
      ],
    },
    {
      qty: getVal("toad_9pa_qty"),
      values: [
        [
          { titleOnly: "Pull-Apart > " },
          { title: "Gap Width", value: getVal("toad_9pa_1gw") },
          { title: "Rail Temp", value: getVal("toad_9pa_2rt") },
        ],
      ],
    },
    {
      qty: getVal("toad_10dp_qty"),
      values: [
        [
          { titleOnly: "De-stressing Performed > " },
          { title: "Length of Track", value: getVal("toad_10dp_1lot") },
          { title: "Rail Removed", value: getVal("toad_10dp_2rr") },
          { title: "New RNT", value: getVal("toad_10dp_3nr") },
        ],
      ],
    },
    {
      qty: getVal("toad_11dp_qty"),
      values: [[{ title: "Other", value: getVal("toad_11dp_1o") }]],
    },
  ];
};



// WEBPACK FOOTER //
// ./src/components/Reports/SCFE/RecordOfDisturbanceReport/RecordOfDisturbanceSchema.jsx